import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  getAIConversations,
  getAIMessages,
  updateAIMessages,
  deleteAIMessage
} from '../../actions';
import { FerrisWheelSpinner } from 'react-spinner-overlay';
import { BsTrash, BsArrowUpCircleFill, BsArrowDownCircleFill, BsChevronUp } from "react-icons/bs";
import {
  Button,
  Container,
  Row,
  Col,
  Badge
} from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

class K3ConversationView extends Component {
  constructor(props) {
    super();
    this.state = {
      aiConversations: [],
      aiMessages: null,
      filteredMessages: [],
      isLoading: true,
      showScrollTop: false,
      showScrollBottom: false,
      collapsedMessages: JSON.parse(localStorage.getItem('collapsedMessages') || '{}'),
    };
  }

  componentDidMount() {
    const conversationId = this.props.match.params.id;
    if (conversationId) {
      this.props.getAIMessages({ conversationId });
    }
    this.props.getAIConversations();

    // Add scroll event listener
    const container = this.findScrollableContainer();
    if (container) {
      container.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    const container = this.findScrollableContainer();
    if (container) {
      container.removeEventListener('scroll', this.handleScroll);
    }
  }

  findScrollableContainer = () => {
    const container = document.querySelector('#k3pl-chat-page div[style*="overflow-y: auto"]');
    if (!container) return null;
    return container;
  }

  handleScroll = () => {
    const container = this.findScrollableContainer();
    if (!container) return;
    
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;
    
    const showScrollTop = scrollTop > 300;
    const showScrollBottom = scrollHeight - scrollTop - clientHeight > 300;
    
    if (this.state.showScrollTop !== showScrollTop || this.state.showScrollBottom !== showScrollBottom) {
      this.setState({ 
        showScrollTop,
        showScrollBottom
      });
    }
  }

  scrollToTop = () => {
    const container = this.findScrollableContainer();
    if (!container) return;
    
    container.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  scrollToBottom = () => {
    const container = this.findScrollableContainer();
    if (!container) return;
    
    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth'
    });
  }

  componentWillReceiveProps(props) {
    const messagesChanged = 
      this.state.aiMessages === null ||
      props.aiMessages.length !== this.state.aiMessages.length ||
      props.aiMessages.some((msg, idx) => 
        !this.state.aiMessages[idx] || msg.id !== this.state.aiMessages[idx].id
      );

    this.setState({
      aiConversations: props.aiConversations,
      aiMessages: props.aiMessages,
      filteredMessages: props.aiMessages || []
    });

    if (messagesChanged) {
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 1000);
    }
  }

  getAIMessageRole = (message) => {
    var role = "assistant_undefined";

    try {
      role = message.message.author.role;
      if (role == "tool") {
        role = "assistant_tool";
      } else if (role == "system") {
        role = "assistant_system";
      }
    } catch (e) {
      console.log(e);
    }

    return role;
  }

  calculateTokens = (text) => {
    try {
      const charCount = text.length;
      const wordCount = text.trim().split(/\s+/).length;
      const estimatedTokens = Math.max(
        Math.ceil(charCount / 4),
        Math.ceil(wordCount / 0.75)
      );
      return estimatedTokens;
    } catch (error) {
      console.error('Error calculating tokens:', error);
      return 0;
    }
  }

  handleDeleteMessage = async (messageId) => {
    try {
      await this.props.deleteAIMessage(messageId);
      toast.success('Message deleted successfully');
      // Refresh messages
      const conversationId = this.props.match.params.id;
      if (conversationId) {
        this.props.getAIMessages({ conversationId });
      }
    } catch (error) {
      console.error('Error deleting message:', error);
      toast.error('Failed to delete message');
    }
  };

  toggleMessageCollapse = (messageId) => {
    console.log('toggleMessageCollapse', messageId);
    const messageElement = document.querySelector(`[data-message-id="${messageId}"]`);
    if (!messageElement) return;

    const isCollapsed = messageElement.classList.contains('collapsed');
    if (isCollapsed) {
      messageElement.classList.remove('collapsed');
      messageElement.style.height = 'auto';
    } else {
      messageElement.classList.add('collapsed');
      messageElement.style.height = '120px';
    }

    // Update icon
    const iconElement = messageElement.querySelector('.btn-collapse-message');
    if (iconElement) {
      iconElement.innerHTML = isCollapsed ? 
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"></path></svg>' :
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg>';
    }

    // Update tooltip after a short delay to ensure DOM updates are complete
    setTimeout(() => {
      const button = messageElement.querySelector('.btn-collapse-message');
      if (button) {
        button.title = messageElement.classList.contains('collapsed') ? 
          'Hiện đầy đủ message' : 
          'Thu gọn message';
      }
    }, 50);

    // Update localStorage
    const newCollapsedMessages = { ...this.state.collapsedMessages };
    if (isCollapsed) {
      delete newCollapsedMessages[messageId];
    } else {
      newCollapsedMessages[messageId] = true;
    }
    this.setState({ collapsedMessages: newCollapsedMessages });
    localStorage.setItem('collapsedMessages', JSON.stringify(newCollapsedMessages));
  };

  renderAIMessage = (message, index, total) => {
    var role = this.getAIMessageRole(message);
    var dateTime = message.message && message.message.create_time? moment(message.message.create_time * 1000).format("YY-MM-DD HH:mm:ss"): "no-data";
    var friendlyRoles = {
      'user': message.user_info.email,
      'assistant': 'ChatGPT',
      'assistant_tool': 'Tool',
      'assistant_system': 'System',
      'assistant_undefined': 'Assistant Undefined'
    }

    var content = `#### ${friendlyRoles[role]} (${dateTime}) \n`;
    var headerContentLength = content.length;

    try {
      var parts = message.message.content.parts.map(part => {
        if (part.content_type) {
          switch (part.content_type) {
            case "audio_transcription":
              return part.text;

            case "image_asset_pointer":
              let imageUrl = "";
              let imageId = "";
              
              if (part.asset_pointer.startsWith("sediment://")) {
                imageId = part.asset_pointer.replace("sediment://", "");
                imageUrl = `/gpt_images/generate/${message.conversation_id}/${imageId}.jpg`;
              } else if (part.asset_pointer.startsWith("file-service://")) {
                imageId = part.asset_pointer.replace("file-service://", "");
                imageUrl = `/gpt_images/upload/${message.conversation_id}/${imageId}.jpg`;
              }
              
              if (imageUrl) {
                return `![${imageId}](${imageUrl})\n`;
              }
              return `[IMAGE ${part.asset_pointer}]\n`;
          }
        }

        try {
          var jsonData = JSON.parse(part);

          if (jsonData.type.includes("code")) {
            var docContent = "```" + jsonData.content + "```";
            jsonData.content = "@";
            return ["```" + JSON.stringify(jsonData) + "```", docContent].join("\n");
          };

          if (jsonData.type == "document") {
            var docContent = jsonData.content;
            jsonData.content = "@";
            return ["```" + JSON.stringify(jsonData) + "```", docContent].join("\n");
          };

          if (jsonData.updates) {
            var jsonContents = jsonData.updates.map(update => {
              var jsonContent = "```" + update.replacement + "```";
              update.replacement = "@";
              return jsonContent;
            })
            return ["```" + JSON.stringify(jsonData) + "```", jsonContents.join("\n --- n")].join("\n");
          }
        } catch {
          // Handle non-JSON content
        }

        if (typeof part === 'string') {
          return part;
          // return part.replace(/\n/g, '\n\n');
        }

        return part;
      })

      content += parts.join("\n");

      if (message.message.metadata.content_references) {
        var contentReferences = message.message.metadata.content_references;
        contentReferences.map(ref => {
          if (ref.matched_text.trim())
            content = content.replace(ref.matched_text, ref.alt);
        });
      }

      if (message.message.content.text) {
        content += `\n\n\`\`\`${message.message.content.text}\`\`\``;
      }

    } catch (e) {
      console.log(e);
    }

    if (content.length == headerContentLength)
      return "";

    return (
      <Col md="6" className="p-2" title={`Message ID: ${message.id}`} data-message-id={message.id}>
        <div className={`p-3 pt-1 ai-message-item message-bg-${role}`} style={{ 
          position: 'relative',
          overflow: 'hidden',
          maxHeight: '100%'
        }}>
          {message.conversation_turn && (
            <span style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              backgroundColor: message.conversation_turn % 2 === 0 ? '#2196F3' : '#ffd700',
              color: message.conversation_turn % 2 === 0 ? '#fff' : '#000',
              padding: '2px 6px',
              borderRadius: '4px',
              fontWeight: 'bold',
              zIndex: 2
            }}>
              #{message.conversation_turn}
            </span>
          )}

          <Button
            variant="link"
            className="btn-collapse-message"
            onClick={() => this.toggleMessageCollapse(message.id)}
            style={{
              position: 'absolute',
              top: '40px',
              right: '13px',
              zIndex: 1,
              padding: '0',
              color: '#6c757d',
              opacity: 0,
              transition: 'opacity 0.2s ease-in-out'
            }}
            title={this.state.collapsedMessages[message.id] ? 
              'Hiện đầy đủ message' : 
              'Thu gọn message'}
          >
            <BsChevronUp size={16} />
          </Button>

          <Badge pill bg="danger" className="message-index-badge">
            {`${dateTime} | ${index}/${total} | ${this.calculateTokens(content)} tokens`}
          </Badge>

          <div className="message-badges">
            <BsTrash
              className="message-delete-badge"
              title="Delete message"
              onClick={e => {
                e.stopPropagation();
                if (window.confirm('Bạn có chắc chắn muốn xóa tin nhắn này?')) {
                  this.handleDeleteMessage(message.id);
                }
              }}
            />
          </div>

          <div className="message-content">
            <ReactMarkdown children={content.replaceAll("\n\n", "\n")}
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]} />
          </div>
        </div>
      </Col>
    );
  }

  render() {
    const { filteredMessages, isLoading } = this.state;
    const conversationId = this.props.match.params.id;
    const conversation = this.state.aiConversations.find(con => con.conversation_id === conversationId);

    return (
      <>
        <Toaster position="top-right" />
        <Container fluid id="k3pl-chat-page"
          className="paper-style"
          style={{ 
            height: 'calc(100vh - 40px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            position: 'relative'
          }}
        >
          {isLoading && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000
            }}>
              <FerrisWheelSpinner loading={true} color="#17a2b8" />
            </div>
          )}

          <Row className="mt-2">
            <Col>
              <h3>{conversation ? conversation.title : 'Conversation'}</h3>
            </Col>
          </Row>

          <Row style={{ 
            flex: 1,
            overflow: 'hidden',
            margin: 0
          }}>
            <div style={{ 
              height: '100%',
              overflowY: 'auto',
              padding: '0 15px'
            }}>
              <Row>
                {filteredMessages.map((message, idx) =>
                  this.renderAIMessage(message, idx + 1, filteredMessages.length)
                )}
              </Row>
            </div>
          </Row>

          {/* Scroll to top button */}
          {this.state.showScrollTop && (
            <Button
              className="scroll-to-top"
              variant="primary"
              onClick={this.scrollToTop}
              title="Scroll to top"
              style={{
                position: 'fixed',
                bottom: '70px',
                right: '20px',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
            >
              <BsArrowUpCircleFill size={24} />
            </Button>
          )}

          {/* Scroll to bottom button */}
          {this.state.showScrollBottom && (
            <Button
              className="scroll-to-bottom"
              variant="primary"
              onClick={this.scrollToBottom}
              title="Scroll to bottom"
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', 
                zIndex: 1000,
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
            >
              <BsArrowDownCircleFill size={24} />
            </Button>
          )}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    aiConversations: state.aiConversationReducer.aiConversations,
    aiMessages: state.aiMessageReducer.aiMessages
  }
}

export default connect(mapStateToProps, {
  getAIConversations,
  getAIMessages,
  updateAIMessages,
  deleteAIMessage
})(K3ConversationView); 